// Mapping of ProseMirror node types to expected XPath names
export const ANNOTATIONS_NODE_TYPE_MAPPING: Record<string, string> = {
  quote_block: "blockquote",
  paragraph: "p",
  code_block: "pre",
  headings_block: "h",
  list_block_0: "ul",
  list_block_1: "li",
  orderedList_block_0: "ol",
  orderedList_block_1: "li",
  powerWord_block: "span",
  keyTerm_block: "span",
  pre_block: "pre",
};

export const ANNOTABLE_INLINE_NODE_TYPES = ["keyTerm_block", "powerWord_block"];
